const coatingData=[
 {name:'PIXAR UV',color:'#58b947',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarUv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection']},
 {name:'PIXAR BLUV',color:'#009fe3',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarBluv.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog','Max UV Protection','Blue Light protection']},
 {name:'PIXAR AQUA',color:'#00b6d7',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAqua.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR DRIVE',color:'#f05a9d',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarDrive.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Anti-fog']},
 {name:'PIXAR ANTIFOG',color:'#d88b4a',img:'https://cdn.shopify.com/s/files/1/0767/8220/7228/files/pixarAntifog.png?v=1779776354',features:['Prevents reflections, presents pure vision','Superhydrophobic, water repellent','Anti-scratch','Anti-dust, easy clean','Blue Light protection']}
];

function renderCoating(i=0){
  const tabs=document.getElementById('coatingTabs'),
        box=document.getElementById('coatingBox');

  if(!tabs || !box) return;

  tabs.innerHTML=coatingData.map((c,n)=>`
    <button class="gt-coating-tab ${n===i?'active':''}" onclick="renderCoating(${n})">
      <img src="${c.img}" alt="${c.name}">
    </button>
  `).join('');

  const iconMap = {
    'Prevents reflections, presents pure vision':'✳',
    'Superhydrophobic, water repellent':'💧',
    'Anti-scratch':'✺',
    'Anti-dust, easy clean':'◎',
    'Anti-fog':'☕',
    'Max UV Protection':'☂',
    'Blue Light protection':'⌁'
  };

  box.innerHTML=coatingData[i].features.map(f=>`
    <div class="gt-feature">
      <div class="gt-icon">${iconMap[f] || '✳'}</div>
      <span>${f}</span>
    </div>
  `).join('');
}

const transLogo='https://cdn.shopify.com/s/files/1/0767/8220/7228/files/transitions.png?v=1781844504';

const lensData={
 "1.50":[
  {name:"Clear",type:"Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:350,rx:[[0,0],[0,0],[-6,6],[-7,6],[-7,6]],colors:""},
  {name:"Transitions",type:"Individual freeform progressive",index:"1.50",abbe:58,density:"1.32",uv:400,rx:[[0,0],[0,0],[-6,6],[-7,6],[-7,6]],colors:"Brown,Smoked",logo:true},
  
 ], 
 
 "1.59 PC":[
  
  {name:"PC Transitions",type:"Individual freeform progressive",index:"1.59",abbe:30,density:"1.22",uv:400,rx:[[0,0],[-0,0],[-6,7],[-6,7],[-6,7]],colors:"Smoked",logo:true},
  
 ]
 
};

let currentIndex="1.50";
let currentMaterial=0;

function safeSetText(id,value){
 const el=document.getElementById(id);
 if(el) el.textContent=value;
}

function safeSetHtml(id,value){
 const el=document.getElementById(id);
 if(el) el.innerHTML=value;
}

function renderTabs(){
 const indexTabs=document.getElementById('indexTabs');
 const materialTabs=document.getElementById('materialTabs');

 if(indexTabs){
  indexTabs.innerHTML=Object.keys(lensData).map(k=>
   `<button class="gt-index-tab ${k===currentIndex?'active':''}" onclick="selectIndex('${k}')">${k}</button>`
  ).join('');
 }

 if(materialTabs){
  materialTabs.innerHTML=lensData[currentIndex].map((m,i)=>{
   const label=m.logo ? `<img src="${transLogo}" alt="${m.name}">` : m.name;
   return `<button class="gt-material-tab ${i===currentMaterial?'active':''}" onclick="selectMaterial(${i})">${label}</button>`;
  }).join('');
 }
}

function selectIndex(i){
 currentIndex=i;
 currentMaterial=0;
 renderAll();
}

function selectMaterial(i){
 currentMaterial=i;
 renderAll();
}

function rxRows(rx){
 const dia=[80,75,70,65,60];
 const vals=rx.flat().filter(v=>v!==0);
 const minRx=Math.min(-18,...vals)-1;
 const maxRx=Math.max(14,...vals)+2;
 const range=maxRx-minRx;

 return rx.map((r,i)=>{
  if(r[0]===0 && r[1]===0){
   return `<div class="gt-rx-row"><div class="gt-rx-dia">${dia[i]}</div><div class="gt-rx-track"></div></div>`;
  }

  const left=((r[0]-minRx)/range)*100;
  const width=((r[1]-r[0])/range)*100;

  return `<div class="gt-rx-row">
   <div class="gt-rx-dia">${dia[i]}</div>
   <div class="gt-rx-track">
    <div class="gt-rx-fill" style="left:${left}%;width:${width}%">
     <span class="gt-rx-left">${r[0]}</span>
     <span class="gt-rx-right">+${r[1]}</span>
    </div>
   </div>
  </div>`;
 }).join('');
}

function renderDetails(){
 const d=lensData[currentIndex][currentMaterial];
 if(!d) return;

 safeSetText('lensType',d.type);
 safeSetText('metricIndex',d.index);
 safeSetText('metricAbbe',d.abbe);
 safeSetText('metricDensity',d.density);
 safeSetHtml('metricUv',d.uv+'<br>nm');

 const densityFill=document.getElementById('densityFill');
 if(densityFill){
  densityFill.style.height=Math.min(100,parseFloat(d.density)/1.5*100)+'%';
 }

 const abbeDonut=document.getElementById('abbeDonut');
 if(abbeDonut){
  const abbePercent=Math.min(100,d.abbe/60*100);
  abbeDonut.style.background=`conic-gradient(var(--gt-blue) 0 ${abbePercent}%,#e3e3e3 ${abbePercent}% 100%)`;
 }

 const rxChart=document.getElementById('rxChart');
 if(rxChart){
  rxChart.innerHTML=rxRows(d.rx);
 }

 let note='Bifocal 28 spectacle lenses are designed to provide clear distance vision and a defined near viewing area for reading and close-up tasks. The segment design offers a practical and economical solution for presbyopic users.';
 if(d.name.toLowerCase().includes('polar')) note+=' By reducing glare from reflections, polarized lenses help increase contrast and support clearer outdoor vision.';
 if(d.name.toLowerCase().includes('transition') || d.name.toLowerCase().includes('wizard')) note+=' The photochromic feature darkens in changing light conditions and helps protect the eyes from harmful UV radiation.';
 if(d.index==="1.53" || d.name.includes("Q-vex")) note+=' Trivex and Q-vex materials provide excellent resistance to breakage and are suitable for rimless and sport spectacles.';
 if(d.index==="1.59") note+=' Polycarbonate material provides impact resistance and added safety, especially for rimless and sport spectacles.';

 safeSetText('lensNote',note);

 safeSetHtml('thinNote',d.thin ? `${d.thin}<small>(compared to 1.50 index organic lenses)</small>` : '');

 const colors=document.getElementById('colorOptions');
 if(colors){
  if(!d.colors){
   colors.innerHTML='';
  }else{
   const colorHtml=d.colors.split(',').map(c=>{
    const clean=c.trim();
    const cls=clean==='Brown'?'brown':clean==='G15'?'g15':'';
    return `${clean} <span class="gt-dot ${cls}"></span>`;
   }).join(' ');
   colors.innerHTML=`Color Options : ${colorHtml}`;
  }
 }
}

function renderAll(){
 renderTabs();
 renderDetails();
}

function gtInitBifocalPage(){
 renderCoating();
 renderAll();
}

if(document.readyState==='loading'){
 document.addEventListener('DOMContentLoaded',gtInitBifocalPage);
}else{
 gtInitBifocalPage();
}